import type {
	useIsUserViewingSpaceAsAnonQuery$data as AnonymousAccessSpaceQueryType,
	useIsUserViewingSpaceAsAnonQuery$variables as AnonymousAccessSpaceQueryVariables,
} from './__generated__/useIsUserViewingSpaceAsAnonQuery.graphql.ts';
import { graphql } from 'react-relay';
import { useQueryInterop } from '@confluence/apollo-relay-interop/entry-points/useQueryInterop.ts';
export const useIsUserViewingSpaceAsAnon = ({
	spaceKey,
	skipQuery,
}: {
	spaceKey: string;
	skipQuery?: boolean;
}) => {
	const { data, loading, error } = useQueryInterop<
		AnonymousAccessSpaceQueryType,
		AnonymousAccessSpaceQueryVariables
	>(
		graphql`
			query useIsUserViewingSpaceAsAnonQuery($spaceKey: String) {
				space(key: $spaceKey) {
					id
					currentUser {
						isAnonymouslyAuthorized
					}
				}
			}
		`,
		{
			variables: { spaceKey },
			skip: skipQuery || !spaceKey,
		},
	);

	return {
		isUserViewingSpaceAsAnon: Boolean(data?.space?.currentUser?.isAnonymouslyAuthorized),
		loading,
		error,
	};
};
